/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';
import { GRAPHQL_ENV } from '..';

/**
 * @param {string} brand - baskets or berries
 * @param {string} partNumber - SKU to be fetched
 */

const brandByDomain = {
    1001: '1800flowers',
    1019: 'harryanddavid',
    1009: '1800baskets',
    1025: 'simplychocolate',
    1010: 'fruitbouquets',
    1012: 'cheryls',
    1022: 'personalizationuniverse',
    1002: 'thepopcornfactory',
    1020: 'wolfermans',
    1018: 'stockyards',
    1030: 'personalizationmall',
    1031: 'vitalchoice',
    1027: 'themarket',
    1033: 'thingsremembered',
    1034: 'florists',
    1036: 'cardisle',
    1038: 'celebrations',
};

const findHasPersonalization = (brand, partNumber) => (
    // very important for serializing. add space between bracket and query name + add typenames to query
    gql`{
        findProductPageByPartNumber(brand: "${brandByDomain[brand]}", environment: "${GRAPHQL_ENV}", partNumber: "${partNumber}")
        {
            product {
                isPersonalizable
                productSkus {
                    personalization {
                        personalizationDefDesign
                        personalizationTemplate
                        indicator
                        lines {
                            lineNumber
                            maxChars
                        }
                    }
                }
            }
            __typename
        }
    }
`
);

export default findHasPersonalization;
